import { EMPTY, OpenError } from "@hpke/common";
import { EncryptionContextImpl } from "./encryptionContext.js";
export class RecipientContextImpl extends EncryptionContextImpl {
    async open(data, aad = EMPTY) {
        let pt;
        try {
            pt = await this._ctx.key.open(this.computeNonce(this._ctx), data, aad);
        }
        catch (e) {
            throw new OpenError(e);
        }
        this.incrementSeq(this._ctx);
        return pt;
    }
}
